var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglassIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 10.5001L6.43894 7.5328C5.90989 7.09193 5.64537 6.8715 5.45521 6.60128C5.28671 6.36186 5.16158 6.0947 5.08552 5.81198C4.99967 5.4929 4.99967 5.14857 4.99967 4.45992V2.16675M9.99967 10.5001L13.5604 7.5328C14.0895 7.09193 14.354 6.8715 14.5441 6.60128C14.7126 6.36186 14.8378 6.0947 14.9138 5.81198C14.9997 5.4929 14.9997 5.14857 14.9997 4.45992V2.16675M9.99967 10.5001L6.43894 13.4674C5.90989 13.9082 5.64537 14.1287 5.45521 14.3989C5.28671 14.6383 5.16158 14.9055 5.08552 15.1882C4.99967 15.5073 4.99967 15.8516 4.99967 16.5402V18.8334M9.99967 10.5001L13.5604 13.4674C14.0895 13.9082 14.354 14.1287 14.5441 14.3989C14.7126 14.6383 14.8378 14.9055 14.9138 15.1882C14.9997 15.5073 14.9997 15.8516 14.9997 16.5402V18.8334M3.33301 2.16675H16.6663M3.33301 18.8334H16.6663",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassIcon);
export default __webpack_public_path__ + "static/media/hourglassIcon.3eb9c7b4d40b69c66e70cd260e81f70b.svg";
export { ForwardRef as ReactComponent };